var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _path, _g23;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRCartPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "magnifying-glass"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "search"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "btn-secondary",
    serifid: "btn secondary"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "ph-desktop"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "ph-note-pencil"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "ph-pen-nib"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-5",
    serifid: "Rating 5"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-4-5",
    serifid: "Rating 4,5"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-4",
    serifid: "Rating 4"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-3-5",
    serifid: "Rating 3,5"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-3",
    serifid: "Rating 3"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-2-5",
    serifid: "Rating 2,5"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-2",
    serifid: "Rating 2"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-1-5",
    serifid: "Rating 1,5"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-1",
    serifid: "Rating 1"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "magnifying-glass1",
    serifid: "magnifying-glass"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "file"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "file-earmark"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "file1",
    serifid: "file"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "boxes-stacked"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "chat-left-text"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "magnifying-glass2",
    serifid: "magnifying-glass"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "iconR-cart-plus",
    x: 0,
    y: 0,
    width: 23.998,
    height: 23.998,
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.52,16.447c-1.03,0 -1.866,0.836 -1.866,1.865c0,1.03 0.836,1.866 1.866,1.866c1.029,-0 1.865,-0.836 1.865,-1.866c-0,-1.029 -0.836,-1.865 -1.865,-1.865Zm10.627,-0.003c-1.03,-0 -1.866,0.835 -1.866,1.865c0,1.029 0.836,1.865 1.866,1.865c1.029,0 1.865,-0.836 1.865,-1.865c-0,-1.03 -0.836,-1.865 -1.865,-1.865Zm-12.581,-11.21c-0,-0 -1.894,-0.011 -1.897,-0.011c-0.232,-0 -0.47,-0.232 -0.47,-0.487l0,-0.436c0,-0.25 0.241,-0.479 0.47,-0.479c0.002,-0 2.42,0.011 2.42,0.011c-0,-0 0.49,-0.001 0.666,0.479c0.244,0.667 0.262,0.709 0.341,0.923c0.228,0 0.736,-0 2.063,-0c0.02,-0 0.039,0.008 0.053,0.022c0.014,0.014 0.021,0.033 0.021,0.052l0,1.253c0,0.041 -0.033,0.075 -0.074,0.075c0,-0 -1.557,0.004 -1.557,0.004l3.013,8.278c0,-0 10.751,-2.491 10.751,-2.491c-0,-0 -0.001,-5.794 -0.001,-5.794l-1.265,0c-0.041,0 -0.075,-0.033 -0.075,-0.074l0,-1.251c0,-0.019 0.008,-0.038 0.022,-0.052c0.014,-0.014 0.033,-0.022 0.053,-0.022l1.759,0c0.493,-0 0.94,0.468 0.94,0.934c0,0.011 -0.003,5.045 -0.003,6.538c0,0.812 -0.681,0.994 -0.875,1.045c0,-0 -10.828,2.488 -11.632,2.672c-0.164,0.037 -0.282,0.009 -0.315,0.004c-0.36,-0.056 -0.47,-0.369 -0.488,-0.412c-0,-0 -3.639,-10.002 -3.92,-10.781Zm8.358,1.455l-1.843,0c-0.393,0 -0.712,0.319 -0.712,0.712c0,0.393 0.319,0.712 0.712,0.712l1.843,-0l0,1.852c0,0.393 0.319,0.712 0.712,0.712c0.393,0 0.712,-0.319 0.712,-0.712l0,-1.852l1.844,-0c0.392,-0 0.711,-0.319 0.711,-0.712c0,-0.393 -0.319,-0.712 -0.711,-0.712l-1.844,0l0,-1.852c0,-0.393 -0.319,-0.712 -0.712,-0.712c-0.393,-0 -0.712,0.319 -0.712,0.712l0,1.852Z"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "pin-map"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRCartPlus);
export default __webpack_public_path__ + "static/media/iconR-cart-plus.a7d3c5a25bcd9a74094e9797f323bd1e.svg";
export { ForwardRef as ReactComponent };